var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart-trading-view',{attrs:{"auto-init":"","top-toolbar":"","style-area":false,"slug":_vm.coinSlug,"symbol":_vm.coinSymbol}})}
var staticRenderFns = []

export { render, staticRenderFns }